import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Row, RegistryModel } from 'shared/lib';

export type RegistryTopBarProps = ComponentPropsWithoutRef<'div'> & {
	alwaysShow?: boolean;
};

export const createRegistryTopBar = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryTopBar = forwardRef<HTMLDivElement, RegistryTopBarProps>(
		({ alwaysShow, children, className, ...props }, ref) => {
			const empty = useUnit(model.$empty);

			return (
				(!empty || alwaysShow) && (
					<div
						ref={ref}
						className={clsx('registry-top-bar', className)}
						{...props}
					>
						{children}
					</div>
				)
			);
		},
	);

	return RegistryTopBar;
};
